var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content content-fixed content-auth" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass:
            "media align-items-stretch justify-content-center ht-100p pos-relative"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "sign-wrapper mg-lg-l-50 mg-xl-l-60" }, [
            _c("div", { staticClass: "wd-100p" }, [
              _c("h3", { staticClass: "tx-color-01 mg-b-5" }, [
                _vm._v("Sign In")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "tx-color-03 tx-16 mg-b-40" }, [
                _vm._v("Welcome back! Please signin to continue.")
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "user",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.signin($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("ID")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.uid,
                          expression: "uid"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "exampleInputEmail",
                        placeholder: "Enter your ID"
                      },
                      domProps: { value: _vm.uid },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.uid = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        id: "exampleInputPassword",
                        placeholder: "Password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "custom-control custom-checkbox small" },
                    [
                      _c("input", {
                        staticClass: "custom-control-input",
                        attrs: { type: "checkbox", id: "customCheck" },
                        domProps: { checked: _vm.checked },
                        on: {
                          click: function($event) {
                            return _vm.checkbox()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customCheck" }
                        },
                        [_vm._v("Remember Me")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.msg))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", { staticClass: "btn btn-brand-02 btn-block" }, [
                    _vm._v("Sign In")
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "media-body align-items-center d-none d-lg-flex" },
      [
        _c("div", { staticClass: "mx-wd-600" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: { src: require("../../assets/img/login.png"), alt: "" }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-between mg-b-5" }, [
      _c("label", { staticClass: "mg-b-0-f" }, [_vm._v("Password")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-919c2988", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-919c2988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/Signin.vue
// module id = null
// module chunks = 